import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, X } from 'lucide-react';

/**
 * PWA Update Notification Component
 * Shows when a new version of the app is available
 */
const PWAUpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    // Listen for update available event from service worker
    const handleUpdateAvailable = () => {
      setShowUpdate(true);
    };

    window.addEventListener('pwa-update-available', handleUpdateAvailable);

    return () => {
      window.removeEventListener('pwa-update-available', handleUpdateAvailable);
    };
  }, []);

  const handleUpdate = () => {
    // Reload to get the new version
    window.location.reload();
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  if (!showUpdate) {
    return null;
  }

  return (
    <div className="fixed top-4 left-4 right-4 z-50 animate-in slide-in-from-top duration-300">
      <div className="max-w-md mx-auto bg-[#1A237E] text-white rounded-xl shadow-lg p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
            <RefreshCw className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-sm">Mise à jour disponible</h4>
            <p className="text-xs text-white/80 mt-1">
              Une nouvelle version de DOCKHTA est disponible.
            </p>
            <div className="flex gap-2 mt-3">
              <Button 
                size="sm"
                variant="ghost"
                onClick={handleDismiss}
                className="text-white hover:bg-white/20 text-xs h-8"
              >
                Plus tard
              </Button>
              <Button 
                size="sm"
                onClick={handleUpdate}
                className="bg-white text-[#1A237E] hover:bg-white/90 text-xs h-8"
              >
                <RefreshCw className="w-3 h-3 mr-1" />
                Mettre à jour
              </Button>
            </div>
          </div>
          <button 
            onClick={handleDismiss}
            className="w-6 h-6 rounded-full hover:bg-white/20 flex items-center justify-center"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAUpdateNotification;
